'use client'
import { Publicprofile } from '@/payload-types'
import Image from 'next/image'
import SeeProfileBtn from '../button/seeProfileBtn'
import { RenderPublicDetails } from '@/components/public-profile-card/profileDetails'
import { ImageComponent } from '../media/imageComponent'
import { TypesenseData } from '@/lib/typesenseFunction'
import PopupComponent from '../popup/popup'
import { useState } from 'react'
interface IProps {
  profileData: (string | null) | Publicprofile | TypesenseData
  profilePicture?: { pictureDivCSS?: string; pictureCSS?: string }
  profileFullName?: { fullNameDivCSS?: string; fullNameCSS?: string }
  moreDetails?: {
    ifShow?: boolean
    ifFlex?: boolean
    value: { label: string | null; value: string | null }[]
    showMore?: boolean
    detailsCSS?: string
    allItems?: boolean
  }
  profileDescription?: { ifShow?: boolean; descriptionNode?: React.ReactNode }
  seeProfileBtn?: { ifShow?: boolean; btnCSS?: string }
  informationCSS?: string
  openImagePopup?: boolean
}

export const ProfileCardComponent = ({
  profileData,
  profilePicture,
  profileFullName,
  moreDetails = {
    ifShow: false,
    ifFlex: false,
    value: [
      {
        label: null,
        value: null,
      },
    ],
  },
  profileDescription = { ifShow: false },
  seeProfileBtn = { ifShow: false },
  informationCSS,
  openImagePopup = false,
}: IProps) => {
  const [showImagePopup, setShowImagePopup] = useState(false)
  let imageUrl, imageAlt, fullName, href, imagePopupUrl
  if (
    profileData &&
    typeof profileData === 'object' &&
    'profileEntity' in profileData &&
    typeof profileData?.profileEntity === 'object'
  ) {
    const isProfessor = profileData?.profileEntity.status?.includes('Professor')
    href = isProfessor ? `/professor/${profileData.slug}` : `/individual/${profileData.slug}`
    imageUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''}${
      typeof profileData?.profileImage === 'object'
        ? profileData?.profileImage?.sizes?.webp?.url
        : ''
    }`
    imagePopupUrl = `${
      process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
    }${
      typeof profileData?.profileImage === 'object'
        ? profileData?.profileImage?.sizes?.medium?.url
        : ''
    }`
    imageAlt = profileData?.profileEntity.fullName
      ? profileData?.profileEntity.fullName
      : 'Profile Image'
    fullName = profileData?.profileEntity.fullName
  } else {
    if (profileData && typeof profileData === 'object' && !('profileEntity' in profileData)) {
      imageUrl = profileData.profileImage
      imageAlt = ''
      fullName = profileData.fullName
    }
  }
  return (
    <>
      <div className={`relative ${profilePicture?.pictureDivCSS}`}>
        {openImagePopup && showImagePopup && (
          <PopupComponent onClose={() => setShowImagePopup(false)}>
            <ImageComponent
              src={imagePopupUrl ? imagePopupUrl : ''}
              alt={imageAlt ? imageAlt : ''}
            />
          </PopupComponent>
        )}
        <Image
          loading="eager"
          className={`${profilePicture?.pictureCSS} object-cover ${
            openImagePopup && 'cursor-pointer'
          } `}
          src={imageUrl ? imageUrl : ''}
          alt={imageAlt ? imageAlt : ''}
          fill
          onClick={() => {
            setShowImagePopup(true)
          }}
        />
        {profileData &&
          typeof profileData === 'object' &&
          'region' in profileData &&
          profileData.region === 'Canada' && (
            <div className="absolute rounded-[2px] w-[25px] h-[17px] bottom-[13px] right-[10px] shadow-[0_3px_4px_rgba(0,0,0,1)]">
              <Image
                src={'https://cm2cdn.canarymission.org/static/images/canada-flag-icon.svg'}
                alt={'ddd'}
                height={50}
                width={50}
              />
            </div>
          )}
      </div>
      <div className={`flex-1 ${informationCSS}`}>
        <div className={profileFullName?.fullNameDivCSS}>
          <span className={profileFullName?.fullNameCSS}>{fullName}</span>
        </div>
        {moreDetails.ifShow && (
          <div className={moreDetails.detailsCSS}>
            <RenderPublicDetails
              ifFlex={moreDetails.ifFlex}
              arrayOfData={moreDetails.value}
              showMore={moreDetails.showMore}
            />
          </div>
        )}
        {profileDescription?.ifShow && profileDescription?.descriptionNode}
        {seeProfileBtn?.ifShow &&
          profileData &&
          typeof profileData === 'object' &&
          'profileEntity' in profileData && (
            <SeeProfileBtn
              profileData={profileData}
              buttonCSS={seeProfileBtn?.btnCSS}
              href={href}
            />
          )}
      </div>
    </>
  )
}

export default ProfileCardComponent
